import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScBonusesFiltration = styled.div`
  width: 100%;

  & > form {
    display: flex;
    justify-content: center;

    & > div {
      display: grid;
      grid-template-columns: 150px 150px 2.2fr;
      gap: 8px;
      width: 100%;
      max-width: 640px;

      @media (${device.mobileS}) {
        grid-template-columns: 1fr;
        width: 100%;
      }
    }
  }
`;
